import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const assign_estimator = ({ event: { user, kind, data: { estimator_name } } }) =>
  <div className={kind}>
    {estimator_name} was assigned by {user}
  </div>;

assign_estimator.propTypes = {
  event: PropTypes.shape({
    user: PropTypes.string.isRequired,
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      estimator_name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/assign_estimator.jsx